export const TYPES = {
    ROW: 'rows',
    TEXT: 'texts',
    PIT: 'pits',
    IMAGE: 'images'
};

export class EntityManager {

    constructor() {
        this.init();
    }

    init() {
        this.rows = {};
        this.texts = {};
        this.pits = {};
        this.images = {};
    }

    get(type, id) {
        return this[type][id];
    }

    push(type, row) {
        this[type][row.id] = row;
    }

    remove(entity) {
        delete this[`${entity.type}s`][entity.id];
    }

    forEach(t, callback) {
        const types = t === null ? Object.values(TYPES) : (Array.isArray(t) ? t : [t]);
        types.forEach(type => {
            Object.keys(this[type]).forEach(id => {
                const entity = this.get(type, id);
                callback(entity);
            });
        });
    }

    filter(type, validate) {
        const results = [];
        this.forEach(type, entity => {
            if (validate(entity)) results.push(entity);
        });
        return results;
    }

    removeAll() {
        Object.values(TYPES).forEach(type => {
            Object.keys(this[type]).forEach(id => {
                this[type][id].container.destroy();
                delete this[type][id];
            });
        });
    }
}